export const style = {
  Box: {
    viewBox: '0 0 20 20',
    color: (color: string) => {
      return {
        color,
      };
    },
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      fontWeight: 600,
    },
  },
  Title: {
    sx: {
      color: 'action.active',
    },
  },
  Card: {
    sx: {
      flex: 1,
      height: 85,
      paddingBottom: '0px',
    },
  },
  CardContent: {
    sx: {
      padding: '16px 24px',
    },
  },
} as const;
